import { render, staticRenderFns } from "./ArticleSubheading.vue?vue&type=template&id=4db65642&"
import script from "./ArticleSubheading.vue?vue&type=script&lang=ts&"
export * from "./ArticleSubheading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports